import * as CookieConsent from "vanilla-cookieconsent";

export default class CookieBar {
    constructor() {
        // Obtain settings from the configuration
        this.settings = cookiesettings;

        // Prepare the blocks for the preferences modal
        this.blocks = this.prepareBlocks(this.settings.blocks);

        // Run the CookieConsent plugin with the configured settings
        this.runCookieConsent();
    }

    prepareBlocks(blocks) {
        return blocks.map(block => ({
            title: block.title,
            description: block.description,
            linkedCategory: block.toggle_value
        }));
    }

    runCookieConsent() {
        CookieConsent.run({
            categories: {
                necessary: {
                    enabled: true,  // This category is enabled by default
                    readOnly: true  // This category cannot be disabled
                },
                analytics: {}
            },
            current_lang: 'de',
            autoclear_cookies: true,  // Automatically clear cookies (default: false)
            page_scripts: true,  // Run page scripts based on consent (default: false)
            cookie_expiration: 1,  // Cookie expiration in days (default: 182)
            guiOptions: {
                consentModal: {
                    layout: 'cloud',
                    position: 'bottom right',
                    flipButtons: false,
                    equalWeightButtons: false
                },
                preferencesModal: {
                    layout: 'box',
                    flipButtons: false,
                    equalWeightButtons: false
                }
            },
            language: {
                default: 'de',
                translations: {
                    de: {
                        consentModal: {
                            title: this.settings.title,
                            description: this.settings.description,
                            acceptAllBtn: this.settings.accept_all_label,
                            acceptNecessaryBtn: this.settings.deny_all_label,
                            showPreferencesBtn: 'Cookie Einstellungen'
                        },
                        preferencesModal: {
                            title: this.settings.settings_title,
                            savePreferencesBtn: this.settings.save_label,
                            acceptAllBtn: this.settings.accept_all_label,
                            acceptNecessaryBtn: this.settings.deny_all_label,
                            closeIconLabel: this.settings.close_label,
                            sections: this.blocks
                        }
                    }
                }
            }
        });
    }
}
